function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M23,9.11c0,4.61-4.69,5.27-4.74,5.28H15.8a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h2.4c.09,0,3.8-.56,3.8-4.28a4.29,4.29,0,0,0-4.44-4.28.46.46,0,0,1-.47-.28A6.19,6.19,0,0,0,5.32,6.82a.52.52,0,0,1-.19.37.5.5,0,0,1-.41.09A3.09,3.09,0,0,0,1,10.3a2.87,2.87,0,0,0,.78,2.14,3.93,3.93,0,0,0,2.54,1H7.19a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5H4.31a4.9,4.9,0,0,1-3.22-1.23A3.85,3.85,0,0,1,0,10.3,4.08,4.08,0,0,1,4.38,6.23a7.18,7.18,0,0,1,13.47-2.4A5.27,5.27,0,0,1,23,9.11ZM11.85,7.84a.64.64,0,0,0-.16-.11.5.5,0,0,0-.38,0,.64.64,0,0,0-.16.11l-3,3a.5.5,0,0,0,0,.71.5.5,0,0,0,.7,0L11,9.4v9.79a.5.5,0,0,0,1,0V9.4l2.15,2.15a.51.51,0,0,0,.7,0,.5.5,0,0,0,0-.71Z"
})));

var SvgCloudUpload = function SvgCloudUpload(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 23 19.69",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloudUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud-upload.82b24790.svg";
export { ForwardRef as ReactComponent };